import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Image,
  Input,
  Row,
  Select,
  message,
  Tooltip,
  Alert,
} from "antd";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import { CloseOutlined, FieldTimeOutlined, ProductOutlined, SnippetsOutlined } from "@ant-design/icons";
import qs from "query-string";
import { hideLoading, showLoading, useLoadingDispatch } from "../../../context/loadingContext";
import { useNavigate } from "react-router-dom";
import { domain, env, wms_uploads_bucket } from "../../../Components/config";
import AuthService from "../../../Components/auth/AuthService";
import { HelperReminderTasks } from "../../../Components/common/Constants";
import { showMessage } from "../../../Components/Utils/message";
import FormGrid from "../../../Components/common/FormGrid";
import InputBox from "../../../Components/common/InputBox";


const Auth = new AuthService();

const AddHelperReminder = () => {
  const { Option } = Select;
  const { TextArea } = Input;
  const navigate = useNavigate()
  var layoutDispatch = useLoadingDispatch();



  const [allHelpers, setAllHelpers] = React.useState([]);
  const [selectedHelper, setSelectedHelper] = React.useState(null);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [notes, setNotes] = React.useState("");
  
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [alertMessage, setAlertMessage] = useState(null);

  const getAllHelpers = async () => {
     showLoading(layoutDispatch);
     try {
       const response = await Auth.fetch(`/helper/warehouse-helpers`);
       if (response) {
         hideLoading(layoutDispatch);
         if (response?.ack) {
           setAllHelpers(response.warehouse_helpers);
         }
       }
     } catch (err) {
       console.log(err);
     }
   }

  useLayoutEffect(()=> {
    getAllHelpers()
  },[])

  const handleOk = async () => {
    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    if(isEmptyOrUndefined(selectedHelper)) {
    showMessage('error','Please select helper')
    return;
    }
    if(isEmptyOrUndefined(selectedTask)) {
      showMessage('error','Please select task')
      return;
    }
    if(isEmptyOrUndefined(dueDate)) {
      showMessage('error','Please select due date')
      return;
    }
    showLoading(layoutDispatch);
    const dataToSend = {
      warehouse_helper_id : selectedHelper, 
      due_date: dueDate ? dayjs(dueDate).format('YYYY-MM-DD') : null,
      type:selectedTask,
      notes: notes,
      files: currentItemFiles ? currentItemFiles : []
    }
    try {
      const res = await Auth.fetch("/warehouse-helper-reminder/reminder-warehouse-helper", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      })
      if(res?.ack) {
        console.log(res);
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, res?.record_id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
        showMessage('success',res?.message)
        navigate('/helper_reminder')
      } else {
        showMessage('error',res?.message)
      }

    } catch (err) {
      console.log(err);
    } 
    finally {
      // setIsModalOpen(false);
    hideLoading(layoutDispatch);
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: wms_uploads_bucket,
      ContentType: file.file.type,
      Key: env + "/warehouse-reminders-helper/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      console.log('response', response);
      showMessage('error',"File upload failed.")
      throw new Error("File upload failed.");
    }
  };


  const handleTaskChange = (value) => {
    const selected = HelperReminderTasks.find(task => task.id === value);
    setSelectedTask(value);
    setAlertMessage(selected?.message);
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };


  const formItems = [
     {
            label: "Helper",
            value: selectedHelper,
            options: allHelpers,
            onChange: (val) => setSelectedHelper(val ),
            icon: <ProductOutlined style={{ color: "#722ed1"}}/>,
            readOnly: false,
            type: 'select',
            data: 'helpers',
          },
          {
            label: "Tasks",
            value: selectedTask,
            options: HelperReminderTasks,
            onChange: (val) => handleTaskChange(val),
            icon: <ProductOutlined style={{ color: "#1677ff"}}/>,
            readOnly: false,
            type: 'select',
            data: 'constants',
          },
          {
            label: "Due Date",
            value: dueDate,
            onChange: (date) => { setDueDate(date ? dayjs(date, 'YYYY-MM-DD') : null) },
            icon: <FieldTimeOutlined style={{ color: "#1677ff"}}/>,
            readOnly: false,
            type: 'date',
            data: 'constants',
            disabledDate: disabledDate
          },
          
  ]

  const notesItem = {
            label: 'Notes',
            value: notes,
            onChange: (val) => setNotes(val),
            type: 'notes',
            icon: <SnippetsOutlined  style={{ color: "#1677ff"}}/>
          };


  return (
    <>
      <div>
        <div>
            <h3>Add Helper Reminder</h3>
        </div>
        <FormGrid formItems={formItems} />
        <Row>
          <Col span={12}>
          <InputBox inputItem={notesItem} inputType={'notes'}/>
          </Col>
        </Row>
        <>
          <Row gutter={[16, 16]}>
            {/* <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Helper<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              value={selectedHelper}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedHelper(value);
              }}
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {allHelpers.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.first_name}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Tasks<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              value={selectedTask}
              placeholder="Please Select"
              onChange={(value) => {
                handleTaskChange(value);
              }}
            >
              {HelperReminderTasks.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Due Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={"YYYY-MM-DD"}
              value={dueDate}
              onChange={(date) => {
                setDueDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
              disabledDate={disabledDate}
            />
            </Col> */}
            {/* <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <span>
              Notes:
            </span>
                <TextArea value={notes} onChange={(e)=> setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} />
            </Col> */}
          </Row>
          <Divider />

          <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            // onChange={(e) => {
            //   handleSubmitImage(e);
            // }}
            onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
            onChange={(e) => {
                          const myfiles = e.target.files;
                          if (myfiles.length > 10) {
                            showMessage('error',"A maximum of 10 images can be uploaded at a time.");
                            e.target.value = "";
                          } else {
                            handleSubmitImage(e);
                          }
                        }}
          />
        </UploadButton>
      </div>
        <Divider />
      {files?.length > 0 && <h4>Files:</h4>}
                <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {files.name}
                        </li>
                      );
                    })}
                </ul>
      <Divider />
      {
        alertMessage &&  <Alert message={alertMessage} type="info" showIcon />
      }
       
        </>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <Button
            onClick={() => navigate("/helper_reminder")}
            danger
            size="large"
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
            <Button
              type="primary"
              size="large"
              onClick={handleOk}
            >
              Save
            </Button>
        </div>
        </>
      </div>
    </>
  );
};

export default AddHelperReminder;
